import { render, staticRenderFns } from "./ModalTambahArtikel.vue?vue&type=template&id=4fd57cfc&"
import script from "./ModalTambahArtikel.vue?vue&type=script&lang=js&"
export * from "./ModalTambahArtikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports